export const getBaseurl = () => process.env.REACT_APP_REMOTE_API_BASEURL;
